const Api = {
  index: '/',
  search: '/search',
  login: '/login',

  outlook: '/about/mission',
  adviser: '/about/adviser',
  tink_tank: '/about/member',
  tink_tank_details: '/about/member_more',

  activity: '/activity/list',
  activity_details: '/activity/images',

  member: '/trend/list',
  member_details: '/trend/article',

  policy: '/research/list',
  policy_details: '/research/article',

  news: '/mutimedia/press_release',
  news_details: '/mutimedia/press_release/article',
  media: '/mutimedia/media',
  media_details: '/mutimedia/media/article',
}

export default Api;